import { useEffect, useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { fetchEventCatalog } from "@/lib/bf";

const toggle = (l, id) => (l.includes(id) ? l.filter((x) => x !== id) : [...l, id]);

export default function BFEventPkg({ v, set }) {
  const [cat, setCat] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    let live = true;
    setCat(null);
    fetchEventCatalog(v.brand).then((d) => live && setCat(d)).catch(() => live && setCat({ gamas: [], products: [] }));
    return () => { live = false; };
  }, [v.brand]);
  const g = v.pkg_gamas || [];
  const p = v.pkg_products || [];
  const t = q.trim().toLowerCase();
  const shown = (cat?.products || []).filter((x) => p.includes(x.id) || (t && `${x.name} ${x.code}`.toLowerCase().includes(t))).slice(0, 80);
  return (
    <div className="bfc-f is-wide bf-pkg" data-testid="bf-eva-pkg">
      <span className="st-label">Produse din pachet</span>
      <p className="st-hint" data-testid="bf-eva-pkg-sum">{!g.length && !p.length ? "Nimic bifat: se numără toate produsele brandului." : `${g.length} game · ${p.length} produse separate`}</p>
      {!cat ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă produsele…</p> : (
        <>
          <div className="bf-pkg-chips">
            {cat.gamas.map((x) => (
              <button key={x.id} type="button" className={g.includes(x.id) ? "is-on" : ""} onClick={() => set({ ...v, pkg_gamas: toggle(g, x.id) })} data-testid={`bf-eva-pkg-gama-${x.id}`}>
                {g.includes(x.id) && <Check size={12} />} {x.name}
              </button>
            ))}
          </div>
          <input className="bf-smove-q" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Caută un produs anume (nume sau cod)" data-testid="bf-eva-pkg-search" />
          <ul className="bf-smove-list bf-pkg-list">
            {shown.map((x) => (
              <li key={x.id}><button type="button" className={p.includes(x.id) ? "is-on" : ""} onClick={() => set({ ...v, pkg_products: toggle(p, x.id) })} data-testid={`bf-eva-pkg-prod-${x.id}`}>
                <i>{p.includes(x.id) && <Check size={13} />}</i><b>{x.name}</b><small>{x.code}</small>
              </button></li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
